<template>
  <div>
    <portlet
        :icon="'fad fa-file'"
        :title="'My imports'"
        :actions-block="true"
        :fullheight="true"
        class="portlet-pt-20 "
    >
      <template slot="actionsBlock">
        <router-link class="btn btn-primary" :to="{path:'/admin/import/create'}">create</router-link>
        <button class="btn btn-success ml-2" @click="downloadExcel">Example XLSX</button>
      </template>

      <template slot="portletBody">
        <div class="row">
          <div class="col-12">
            <table class="table table-striped">
              <thead>
              <th>Name</th>
              <th>Email</th>
              <th>Options</th>
              </thead>
              <tbody>
              <tr :key="importMap.id" v-for="importMap in imports">
                <td>{{ importMap.importName }}</td>
                <td>{{ importMap.email }}</td>
                <td>
                  <router-link :to="{path:'/admin/import/'+importMap.id}">
                    <i class="fas fa-eye"> </i>
                  </router-link>
                  <i @click="deleteImport(importMap)" class="ml-3 fas fa-trash delete"></i>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </portlet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { swalModals } from "@/mixins/swalModals";
import * as XLSX from "xlsx";

export default {
  name: "ImportIndex",
  mixins: [swalModals],
  data() {
    return {
      imports: [],
      workflows: [
        { id: 'w1', name: 'Approval' },
        { id: 'w2', name: 'Production' },
        { id: 'w3', name: 'Shipping' }
      ]
    };
  },
  firestore() {
    return {
      imports: this.$FB.collection('importMappings').where('companyId', '==', this.getClaims.companyId)
    };
  },
  computed: {
    ...mapGetters('company', ['getCompanyName']),
    ...mapGetters('users', ['getClaims'])
  },
  methods: {
    async deleteImport(importMap) {
      let { isConfirmed } = await this.swalDelete(importMap.importName);
      if (isConfirmed) {
        await this.$FB.collection('importMappings').doc(importMap.id).delete();
        this.swalToastSuccess('Deleted successfully');
      }
    },

    async downloadExcel() {
      // 1️⃣ Workflows sheet

        try {
          const response = await fetch(process.env.VUE_APP_CLOUD_HTTP_API + '/mappedImport/generateExcelExample/'+this.getClaims.companyId); // Your backend endpoint

          // const response = await fetch('http://127.0.0.1:5098/performance-management-tool/europe-west1/http_http/mappedImport/generateExcelExample/'+this.getClaims.companyId); // Your backend endpoint
          if (!response.ok) throw new Error('Failed to fetch Excel');

          const blob = await response.blob(); // Get response as blob
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = 'Example Import.xlsx'; // File name
          document.body.appendChild(a);
          a.click();

          a.remove();
          window.URL.revokeObjectURL(url); // Clean up
        } catch (err) {
          console.error('Download failed', err);
        }
      }

  }
};
</script>

<style scoped>
i {
  cursor: pointer;
}
.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1.5rem;
  width: 100%;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}

.data-preview {
  display: flex;
  margin-top: 5px;
  font-size: 15px;
}
</style>
